
import {Options, Vue} from "vue-class-component";
import {isDefined} from "@/utils";
import Stand from "@/entities/Stand";
import langHelper from "@/locales/langHelper";

@Options({
  props: {
    onClose: {
      required: false,
      type: Function
    }
  }
})
export default class StandDialog extends Vue {

  private isOpen: boolean = false;
  private stand: Stand;
  private backendUrl = process.env.VUE_APP_MAP_BACKEND_URL + '/maps/' + langHelper.getCurrentLang() + '/' + process.env.VUE_APP_PROJECT + '/stand/';
  private onClose: Function;

  constructor(props) {
    super(props);
  }


  public openDialog(stand: Stand): void {
    this.stand = stand;
    this.addClickListener();
    this.isOpen = true;
  }

  public closeDialog(event: Event): void {
    event.stopImmediatePropagation();
    if (isDefined(this.onClose)) {
      this.onClose();
    }
    this.removeClickListener();
    this.isOpen = false;
  }

  private addClickListener() {
    window.addEventListener('click', this.onClick);
  }

  private removeClickListener() {
    window.removeEventListener('click', this.onClick);
  }

  private onClick(event) {
    if (isDefined(this.$refs.container) && this.isOpen) {
      const container = this.$refs.container as any;
      if (isDefined(container)) {
        if (!container.contains(event.target)) {
          this.closeDialog(event);
        }
      }
    }
  }

}
